import { currentEntryHref, isRecord, mergeHistoryState, readHistoryStateKey } from './historyEntryState';

const SEARCH_FEED_HISTORY_STATE_KEY = '__hotpadsSearchFeedIndex';

type SearchFeedHistoryEntry = {
  index: number;
  entryHref: string;
};

export function writeSearchFeedHistoryIndex(index: number): void {
  mergeHistoryState({
    [SEARCH_FEED_HISTORY_STATE_KEY]: { index, entryHref: currentEntryHref() } satisfies SearchFeedHistoryEntry,
  });
}

export function clearSearchFeedHistoryIndex(): void {
  if (readHistoryStateKey(window.history.state, SEARCH_FEED_HISTORY_STATE_KEY) === undefined) return;
  mergeHistoryState({ [SEARCH_FEED_HISTORY_STATE_KEY]: undefined });
}

// The feed card the renter opened from this entry, so Back returns to it instead of the first card.
export function readSearchFeedHistoryIndex(): number {
  if (typeof window === 'undefined') return 0;
  const entry = readHistoryStateKey(window.history.state, SEARCH_FEED_HISTORY_STATE_KEY);
  if (!isRecord(entry) || entry.entryHref !== currentEntryHref()) return 0;
  return typeof entry.index === 'number' && Number.isInteger(entry.index) && entry.index > 0 ? entry.index : 0;
}
